import { render, staticRenderFns } from "./DeleteBox.vue?vue&type=template&id=43a0cdba&scoped=true&"
import script from "./DeleteBox.vue?vue&type=script&lang=js&"
export * from "./DeleteBox.vue?vue&type=script&lang=js&"
import style0 from "./DeleteBox.vue?vue&type=style&index=0&id=43a0cdba&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a0cdba",
  null
  
)

export default component.exports